import { Item } from '../webrtc/agent/interfaces';

export function itemsContainUrl(
  items: Item[] | undefined,
  url: string
): boolean {
  return !!items && items.length > 0 && items.some(i => i.url === url);
}
